<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3346 15L10.0013 18.3333M10.0013 18.3333L6.66797 15M10.0013 18.3333L10.0013 9.75001C9.99654 9.30615 10.0805 8.8658 10.2482 8.45482C10.4159 8.04383 10.664 7.67048 10.978 7.35668L16.668 1.66668M3.33464 1.66668L7.5013 5.83334"
      stroke="#1F2937"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
